import React, { useState, useEffect } from 'react';
// import '../../CustomersDetails/CustomerApporoved/CustomerApproved.css';
import '../../Pages/CompanyAdmin/CustomersDetails/CustomerApporoved/CustomerApproved.css'
import '../../Pages/CompanyAdmin/AccidentVehicle/AccidentVehicle.css';
import axios from '../../axiosInstance';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { Alert } from '@mui/material';
import ActivationModel from './ActivationModel/ActivationModel';
import { Helmet } from 'react-helmet-async';
import VendorMasterEdit from '../../Pages/CompanyAdmin/VendorsDetails/VenderMaster/VendorMasterEdit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DataTable from "react-data-table-component";
import Admin from '../../Pages/CompanyAdmin/AdminHome/SideBar/Admin';
import DownloadIcon from '@mui/icons-material/Download';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import { Search, Download } from "lucide-react";
import { exportToExcel } from '../../Services/exportToExcel';


const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};

const parseDate = (dateString) => {
    const [day, month, year] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day); // Months are 0-indexed in JavaScript
};

const NewVendorApproved = () => {
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info', timestamp: null });
    const [isModalOpen, setModalOpen] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [deleteData, setDeleteData] = useState(null);
    const getDepartment = localStorage.getItem("department");
    console.log("getDepartment", getDepartment)

    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [isGenerated, setIsGenerated] = useState(false);
    const [generatedExcel, setGeneratedExcel] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [marginLeft, setMarginLeft] = useState('30px');
    const [paddingLeft, setPaddingLeft] = useState('30px');

    const [showVendorMasterEdit, setShowVendorMasterEdit] = useState(false);
    const [showPerformance, setShowPerformance] = useState(false);
    const [showVendorTable, setShowVendorTable] = useState(true);
    const [showMap, setShowMap] = useState(false);


    const [selectedId, setSelectedId] = useState(null);
    const [selectedVendorCode, setSelectedVendorCode] = useState(null);
    const [selectedVendorType, setSelectedVendorType] = useState(null);

    const [sortDate, setSortDate] = useState("asc");
    const [selectedRows, setSelectedRows] = useState([]);

    const handleRowsSelected = (state) => {
        setSelectedRows(state.selectedRows);
    }

    const conditionalRowStyles = [
        {
            when: (row) => selectedRows.some(selected => selected.id === row.id),
            style: {
                backgroundColor: '#bdb6b6',
            },
        }
    ];


    console.log("selectedID", selectedId)
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const [searchQuery, setSearchQuery] = useState('');

    const tableCustomStyles = {
        headRow: {
            style: {
                color: '#ffff',
                backgroundColor: 'rgb(169 187 169)',
                fontWeight: "bold",
                fontSize: '13px'
            },
        },
        pagination: {
            style: {
                button: {
                    background: 'none',
                    boxShadow: "none"
                },
            },
        },
        striped: {
            style: {
                default: 'red'
            }
        },
        rows: {
            style: {
                backgroundColor: '#f2f2f2',
            }
        }
    }

    useEffect(() => {
        if (!showVendorMasterEdit) getData();
        if (token === "" || userId === "") {
            console.log("NO USER ID AND NO TOKEN")
        }
    }, [token, userId, navigate, showVendorMasterEdit]);

    useEffect(() => {
        if (alertInfo.show) {
            const timer = setTimeout(() => {
                setAlertInfo({ ...alertInfo, show: false });
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [alertInfo]);

    const generateFile = async () => {
        try {
            setIsLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/dBToExcel/${userId}/vendor`, { headers: { Authorization: `Bearer ${token}` } });
            setGeneratedExcel(response.data.data);
            console.log("resoponse", response.data.data)
            setIsLoading(false);
            setIsGenerated(true);
        } catch (error) {
            setIsLoading(false);
            console.error(error.message);
        }
    };

    const handleConfirm = async (vendorCode, isActive) => {
        await deactive(vendorCode, isActive);
        setModalOpen(false);
    };

    const handleConfirmDelete = async (vendorCode) => {
        await deleteVendor(vendorCode);
        setModalOpen(false);
    }

    const handleCancel = () => {
        setModalOpen(false);
    };

    const openModal = (item) => {
        setModalData(item);
        setModalOpen(true);
    };

    const openDeleteModal = (item) => {
        setDeleteData(item);
        setModalOpen(true);
    }

    const deactive = async (id, isActivate) => {
        const response = await axios({
            method: 'PUT',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/changeActivation/${userId}/${id}/${isActivate}`,
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        getData();
        setAlertInfo({ show: true, message: response.data.message, severity: 'success' });
    };

    const deleteVendor = async (id) => {
        const response = await axios({
            method: 'DELETE',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/deletePotentialVendor/${userId}/${id}`,
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        getData();
        setAlertInfo({ show: true, message: response.data.message, severity: 'success' });
    };



    const getData = async () => {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getWantedVendors/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
        const fetchedData = response.data.data;
        console.log('fetchedata', fetchedData)
        // const formattedData = fetchedData.map(item => ({
        //   ...item,
        //   systemDate: formatDate(item.systemDate),
        // }));
        setData(fetchedData);
        setCurrentItems(fetchedData);
    };



    const view = (id, vehicleNo) => {
        console.log('id123', id)
        navigate('/viewandapproved', { state: { id: id, vehicleNo: vehicleNo } })
    }
    const [gotDetails, setGotDetails] = useState(false)

    const [goturl, setGotUrl] = useState('')
    console.log('goturl', goturl)

    const [downloadStatus, setDownloadStatus] = useState({});

    // const download =async(id)=>{
    //     console.log("ID", id)
    //     const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/downloadZip/${id}`, { headers: { Authorization: `Bearer ${token}` } });
    //     setGotUrl(response.zipUrl)
    //     setGotDetails(true)

    // }

    // const download = async (vendorCode) => {
    //     try {
    //         const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/downloadZip/${vendorCode}`, {
    //             headers: { Authorization: `Bearer ${token}` },
    //         });
    //              setGotUrl(response.zipUrl)
    //     setGotDetails(true)



    //     } catch (error) {
    //         console.error('Download failed:', error);
    //     }
    // };

    const download = async (vendorCode) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/downloadZip/${vendorCode}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            const zipUrl = response.data.zipUrl;

            setDownloadStatus((prev) => ({
                ...prev,
                [vendorCode]: { ready: true, url: zipUrl },
            }));
        } catch (error) {
            console.error('Download failed:', error);
        }
    };


    const handleMap = () => {
        setShowVendorMasterEdit(false)
        setShowPerformance(false)
        setShowVendorTable(false);
        setShowMap(true);
    }

    const viewPerformance = (id, type) => {
        setSelectedVendorCode(id);
        setSelectedVendorType(type);

        console.log("DSFSDFFSDF")
        setShowPerformance(true)
        setShowVendorMasterEdit(false)
        setShowVendorTable(false)
        setShowMap(false);

    }


    const handleUpdate = () => {
        setShowVendorMasterEdit(false);
        setShowPerformance(false)
        setShowVendorTable(true)
        setShowMap(false);

    };


    const [currentItems, setCurrentItems] = useState(data);
    const filteredData = currentItems.filter(row => {
        return row;
        // console.log("ROSWSDFDSFSDF",row.vendorName,  row.first_approval)
        // return !((row.approval === "not_approved" || row.first_approval_at === null) && userId === "EMPID-f2251370-99ac-40ee-a05d-dcc37c3534e2");
    })
    console.log("filterData", filteredData)


    const columns = [
        {
            name: "ID",
            selector: row => row.id, // Raw data for sorting
            cell: row => <span>{String(row.id).padStart(4, '0')}</span>, // Display formatted value
            sortable: true,
            sortFunction: (rowA, rowB) => rowA.id - rowB.id, // Custom sort function
            style: { width: "200px" }
        },

        // {
        //   name: "VendorId",
        //   selector: row => row.vendorIdentity, // Raw data for sorting
        //   cell: row => <span>{row.vendorIdentity ?`${row.vendorIdentity.substring(0, 2)}${String(row.vendorIdentity.substring(2)).padStart(4, '0')}`:''}</span>      , // Display formatted value
        //   sortable: true,
        //   style: { width: "200px" }
        // },

        {
            name: "Date",
            selector: (row) => row.systemDate,
            sortable: true,
            sortFunction: (rowA, rowB) => {
                const dateA = parseDate(rowA.systemDate);
                const dateB = parseDate(rowB.systemDate);
                return dateA - dateB; // Ascending order
            },
        },
        {
            name: "Name", selector: (row) => row.vendorName, sortable: true, width: "150px",
            cell: (row) => (
                <span style={{ color: 'brown' }}>{row.vendorName.charAt(0).toUpperCase() + row.vendorName.slice(1)}</span>
            )
        },
        { name: "KYC Update", selector: (row) => row.isUpdatedKYC == 1 ? "Yes" : row.isUpdatedKYC == 2 ? "Approved" : 'No', sortable: true },
        { name: "Vehicle Update", selector: (row) => row.isUpdatedVehicles == 1 ? "Yes" : row.isUpdatedVehicles == 2 ? "Approved" : "No", sortable: true },
        {
            name: "Type", selector: (row) => row.vendorType, sortable: true,
            cell: (row) => (
                <span style={{ color: 'black', padding: '5px', borderRadius: '4px', border: "2px solid grey" }}>
                    {/* {row.vendorType ? row.vendorType.charAt(0).toUpperCase() + row.vendorType.slice(1).toLowerCase() : ""} */}
                    Crane
                </span>
            ),
        },
        // {
        //   name: "Pre Approval", selector: (row) => row.first_approval, sortable: true, width: "150px",
        //   cell: (row) => (
        //     <span style={{ color: 'brown' }}>{row.first_approval ?row.first_approval.charAt(0).toUpperCase() + row.first_approval.slice(1) : ''}</span>
        //   )
        // },
        {
            name: "Fianl Approval", selector: (row) => row.second_approval, sortable: true, width: "150px",
            cell: (row) => (
                <span style={{ color: 'brown' }}>{row.second_approval ? row.second_approval.charAt(0).toUpperCase() + row.second_approval.slice(1) : ""}</span>
            )
        },
        {
            name: "Phone No", selector: (row) => row.vendorPhone, sortable: true,
            cell: (row) => (
                <span style={{ color: 'blue', padding: '5px', borderRadius: '4px' }}>
                    {row.vendorPhone ? row.vendorPhone.charAt(0).toUpperCase() + row.vendorPhone.slice(1).toLowerCase() : ""}
                </span>
            ),
        },
        {
            name: "Added By",
            selector: (row) => row.login_mobile || '',
            sortable: true,
            cell: (row) => {
                const login_mobile = row.login_mobile ? String(row.login_mobile) : "";
                return (
                    <span style={{ color: "green" }}>
                        {login_mobile}
                    </span>
                );
            },
        },


        { name: "District", selector: (row) => row.district, sortable: true },


        { name: "Type of Agreement", selector: (row) => row.typeOfAgreement, sortable: true },

        // {
        //     name: "Agreement",
        //     cell: (row) => {
        //         const vendorCode = row.vendorCode;
        //         const vendorStatus = downloadStatus[vendorCode];

        //         return (
        //             <>
        //                 {vendorStatus?.ready ? (
        //                     <a href={vendorStatus.url} target="_blank" rel="noopener noreferrer">
        //                         <DownloadIcon style={{ fontSize: "20px", borderRadius: '100%' }} />
        //                     </a>
        //                 ) : (
        //                     <button onClick={() => download(vendorCode)}>
        //                         <RequestPageIcon style={{ fontSize: "20px", borderRadius: '100%' }} />
        //                     </button>
        //                 )}
        //             </>
        //         );
        //     },
        //     ignoreRowClick: true,
        //     allowOverflow: true,
        //     button: true,
        // },               
        {
            name: "Actions",
            cell: (row) => (
                <button
                    onClick={() => view(row.vendorCode, row.vehicleNo)}
                    className='view-button'
                >
                    View
                </button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }
    ];

    if (getDepartment !== "Administration") {
        columns.push({
            name: "Delete Vendor",
            cell: (row) => (
                <span
                    onClick={() => openDeleteModal(row)}
                    style={{ cursor: 'pointer' }}
                >
                    <DeleteOutlineIcon />
                </span>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        });
    }

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchValue(value);

        const newRows = data.filter((row) => {
            const formattedId = String(row.id).padStart(4, '0').toLowerCase(); // Make sure the formatted ID is lowercase
            const searchLower = value; // Use the updated search value directly

            const idValue = formattedId.includes(searchLower);
            const dateValue = (formatDate(row.systemDate) ?? '').toLowerCase().includes(searchLower);
            const vendorNameValue = (row.vendorName ?? '').toLowerCase().includes(searchLower);
            const emailValue = (row.email ?? '').toLowerCase().includes(searchLower);
            const vendorPhoneValue = (row.vendorPhone ?? '').toLowerCase().includes(searchLower);
            const vendorTypeValue = (row.vendorType ?? '').toLowerCase().includes(searchLower);
            const editedByValue = (row.EditedBy ?? '').toLowerCase().includes(searchLower);
            const districtValue = (row.district ?? '').toLowerCase().includes(searchLower);
            // const vendorIdValue = (row.vendorIdentity ?? '').toLowerCase().includes(searchLower);
            const vendorIdValue = (row.vendorIdentity ? `${row.vendorIdentity.substring(0, 2)}${String(row.vendorIdentity.substring(2)).padStart(4, '0')}` : "" ?? '').toLowerCase().includes(searchLower);


            return vendorIdValue || idValue || vendorPhoneValue || dateValue || vendorNameValue || emailValue || vendorTypeValue || editedByValue || districtValue;
        });

        setCurrentItems(newRows);
    };

    const [searchValue, setSearchValue] = useState('');

    const [filterType, setFilterType] = useState('completed');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const handleSubmit = async () => {
        console.log('handleSubmit calling: ')
        setIsLoading(true);
        setIsGenerated(false);

        console.log({

            filter: filterType,
            from: fromDate,
            to: toDate
        })

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/getWholeDetailsForAdmin`, {

                filter: filterType,
                from: fromDate,
                to: toDate
            });
            const fetchedData = response.data.data;
            console.log('==============')
            console.log(fetchedData)

            const formattedData = fetchedData.map(item => ({
                ...item,
                systemDate: item.systemDate ? formatDate(item.systemDate) : "",

            }));

            // console.log(formattedData)
            // setData(formattedData);
            setCurrentItems(formattedData);

        } catch (error) {
            console.log(error)
        }


        return
        // 
        try {

            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/generate-excel`, {
                search: searchValue,
                filter: filterType,
                from: fromDate,
                to: toDate
            });

            if (response.data && response.data.fileUrl) {
                setGeneratedExcel(response.data.fileUrl);
                setIsGenerated(true);
            } else {
                alert('Excel file generation failed.');
            }
        } catch (error) {
            console.error('Error generating Excel:', error);
            alert('Something went wrong while generating the Excel file.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleExport = () => {
        // Export only selected rows if any, otherwise export all current items
        const exportData = selectedRows.length > 0 ? selectedRows : currentItems;
        // console.log(currentItems)
        exportToExcel(exportData, "Report");
    };


    return (
        <div style={{marginTop: "-20px"}}>


            <Admin />
            {showVendorTable && (
                <div className="Customer-master-form" style={{ marginLeft: '10px', paddingLeft: '0px', marginRight: '10px', paddingRight: '0px' }}>
                    <Helmet>
                        <title>Vendor Information - Claimpro</title>
                        <meta name="description" content="Vendor Information Claimpro." />
                        <meta name="keywords" content="Vehicle Accidents, accident trucks, vendor service, Customer Service, Claimpro, Claim pro Assist, Claimpro Assist, Accidental repair, Motor Insurance claim, Advocate services, Hydra Crane service, On site repair, Accident Management" />
                        <link rel='canonical' href={`https://claimpro.in/VendorApporoved`} />
                    </Helmet>


                    <div style={{marginTop: "-35px"}}>
                        <h3 className="bigtitle ms-5 container">Sign-up Vendors</h3>

                        <div className='container ms-5 mt-3' >
                            <style>
                                {`
                                                                       .form-search {
                                                                           display: flex;
                                                                           flex-wrap: wrap;
                                                                           gap: 10px;
                                                                       }
                           
                                                                       @media (max-width: 768px) {
                                                                           .form-search {
                                                                           gap: 3px;
                                                                           //   padding-right: 25px; /* ✅ Add spacing on right side */
                                                                           margin-right: 25px; /* ✅ Add spacing on right side */
                                                                           //   padding-left: -5px;  /* (Optional) to center more nicely */
                                                                           }
                           
                                                                           .form-search > div {
                                                                           flex: 1 1 100% !important;
                                                                           min-width: 100% !important;
                                                                           }
                                                                       }
                                                           `}
                            </style>

                            {/* below hidden div is unused, can be removed */}
                            <div hidden className="form-search">
                                {/* Search */}
                                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                                    <label className="label-class" style={{ width: '100%' }}>
                                        Search by
                                        <input
                                            type="search"
                                            className="form-control-sm border ps-3"
                                            placeholder="Search"
                                            // value={searchValue}
                                            onChange={handleSearch}
                                            style={{ width: '100%' }}
                                        />
                                    </label>
                                </div>

                                {/* Filter Dropdown */}
                                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                                    <label className="label-class" style={{ width: '100%' }}>
                                        Filter:
                                        <select
                                            className="form-control-sm border ps-2"
                                            // value={filterType}
                                            // onChange={e => setFilterType(e.target.value)}
                                            style={{ width: '100%' }}
                                        >
                                            <option value="completed">Completed</option>
                                            <option value="pre-canceled">Pre-canceled</option>
                                            <option value="canceled">Canceled</option>
                                        </select>
                                    </label>
                                </div>

                                {/* From Date */}
                                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                                    <label className="label-class" style={{ width: '100%' }}>
                                        From:
                                        <input
                                            type="date"
                                            className="form-control-sm border ps-2"
                                            // value={fromDate}
                                            // onChange={e => setFromDate(e.target.value)}
                                            style={{ width: '100%' }}
                                        />
                                    </label>
                                </div>

                                {/* To Date */}
                                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                                    <label className="label-class" style={{ width: '100%' }}>
                                        To:
                                        <input
                                            type="date"
                                            className="form-control-sm border ps-2"
                                            // value={toDate}
                                            // onChange={e => setToDate(e.target.value)}
                                            style={{ width: '100%' }}
                                        />
                                    </label>
                                </div>

                                {/* Generate/Download Excel Button */}
                                <div style={{ flex: '1 1 200px', minWidth: '200px', marginTop: "10px" }}
                                // onClick={handleSubmit}
                                // onMouseEnter={() => setIsHovered(true)}
                                // onMouseLeave={() => setIsHovered(false)}
                                >
                                    <label className="label-class" style={{ width: '100%', display: 'block' }}>
                                        &nbsp; {/* Placeholder to align */}

                                        <a
                                            // href={generatedExcel}
                                            onClick={handleSubmit}
                                            className="form-control download-link"
                                            style={{ textAlign: 'center' }}
                                        >
                                            Search
                                        </a>

                                    </label>
                                </div>
                            </div>

                            <div >
                                {/* Embedded CSS for responsiveness */}
                                <style>
                                    {`
                               .form-search {
                                 display: flex;
                                 flex-wrap: wrap;
                                 gap: 10px;
                               }
                             
                               @media (max-width: 768px) {
                                 .form-search {
                                   gap: 3px;
                                 //   padding-right: 25px; /* ✅ Add spacing on right side */
                                   margin-right: 25px; /* ✅ Add spacing on right side */
                                 //   padding-left: -5px;  /* (Optional) to center more nicely */
                                 }
                             
                                 .form-search > div {
                                   flex: 1 1 100% !important;
                                   min-width: 100% !important;
                                 }
                               }
                             `}
                                </style>


                                {/* <h3 className="bigtitle">Sign-up Vendor</h3> */}

                                <div className="form-search flex">

                                    {/* Search */}
                                    <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                                        <label className="label-class" style={{ width: '100%' }}>
                                            Search by
                                            <input
                                                type="search"
                                                className="form-control-sm border ps-3"
                                                placeholder="Search"
                                                // value={searchValue}
                                                onChange={handleSearch}
                                                style={{ width: '100%' }}
                                            />
                                        </label>
                                    </div>

                                    {/* Filter Dropdown */}
                                    <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                                        <label className="label-class" style={{ width: '100%' }}>
                                            Filter:
                                            <select
                                                className="form-control-sm border ps-2"
                                                value={filterType}
                                                onChange={e => setFilterType(e.target.value)}
                                                style={{ width: '100%' }}
                                            >
                                                <option value="completed">Completed</option>
                                                <option value="pre-cancelled">Pre-cancelled</option>
                                                <option value="post-cancelled">Cancelled</option>
                                            </select>
                                        </label>
                                    </div>

                                    {/* From Date */}
                                    <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                                        <label className="label-class" style={{ width: '100%' }}>
                                            From:
                                            <input
                                                type="date"
                                                className="form-control-sm border ps-2"
                                                value={fromDate}
                                                onChange={e => setFromDate(e.target.value)}
                                                style={{ width: '100%' }}
                                            />
                                        </label>
                                    </div>

                                    {/* To Date */}
                                    <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                                        <label className="label-class" style={{ width: '100%' }}>
                                            To:
                                            <input
                                                type="date"
                                                className="form-control-sm border ps-2"
                                                value={toDate}
                                                onChange={e => setToDate(e.target.value)}
                                                style={{ width: '100%' }}
                                            />
                                        </label>
                                    </div>

                                    {/* Buttons */}
                                    <div className='flex  gap-2 '>

                                        {/* <Search
                                     className="w-6 h-6 text-gray-600 cursor-pointer transition-transform transform hover:scale-125 hover:text-gray-600"
                                   />
                 
                                   <Download
                                     className="w-6 h-6 text-gray-600 cursor-pointer transition-transform transform hover:scale-125 hover:text-blue-600"
                                   /> */}

                                        <button onClick={handleSubmit}>
                                            <Search className="w-6 h-6 text-gray-600" />
                                        </button>
                                        <button onClick={handleExport}>
                                            <Download className="w-6 h-6 text-gray-600" />
                                        </button>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>


                    {alertInfo.show && (
                        <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
                            {alertInfo.message}
                        </Alert>
                    )}
                    {/* <p
          style={{
            display: 'flex',
            marginRight: "5px",
            cursor: "pointer"
          }}
          onClick={sortDateFunc}
        >
          {sortDate === "asc" ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
        </p> */}
                    <div className="container d-flex justify-content-center " >
                        <div className="container my-4 max-w-[95vw]">
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                fixedHeader
                                pagination
                                selectableRows
                                onSelectedRowsChange={handleRowsSelected}
                                conditionalRowStyles={conditionalRowStyles}
                                customStyles={tableCustomStyles}
                            />
                        </div>
                    </div>


                    {modalData && (
                        <ActivationModel
                            isOpen={isModalOpen}
                            onConfirm={() => handleConfirm(modalData.vendorCode, modalData.isActive === "true" ? "false" : "true")}
                            onCancel={handleCancel}
                        />
                    )}

                    {deleteData && (
                        <ActivationModel
                            isOpen={isModalOpen}
                            onConfirm={() => handleConfirmDelete(deleteData.vendorCode)}
                            onCancel={handleCancel}
                        />
                    )}

                </div>)}
            {showVendorMasterEdit && (
                <VendorMasterEdit id={selectedId} onUpdate={handleUpdate} pageFrom='VendorSignUp' />
            )}


        </div>
    );
};

export default NewVendorApproved;
